/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:fe1467e0-293d-4a8c-959d-4d1e6ce4d226",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_5tlSs3608",
    "aws_user_pools_web_client_id": "7kjloi8dkgu4ofj9m3thihvkim",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "labshipdocs-prod223512-prod",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
